module.exports = __webpack_public_path__ + "img/cfs.7a013a7f.png";